import React from 'react';
import { Skeleton } from '../ui/Skeleton';

export default function SkeletonFormResponses() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-pulse">
      {/* Header */}
      <div className="mb-6">
        <Skeleton className="h-4 w-20 mb-3" rounded="rounded" />
        <div className="flex items-center justify-between">
          <div>
            <Skeleton className="h-7 w-48 mb-2" rounded="rounded" />
            <Skeleton className="h-4 w-24" rounded="rounded" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-9 w-9" rounded="rounded-lg" />
            <Skeleton className="h-9 w-9" rounded="rounded-lg" />
            <Skeleton className="h-9 w-24" rounded="rounded-lg" />
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 overflow-hidden">
        {/* Table header */}
        <div className="grid grid-cols-4 gap-4 px-6 py-3 border-b border-gray-100 dark:border-gray-700">
          <Skeleton className="h-3 w-20" rounded="rounded" />
          <Skeleton className="h-3 w-16" rounded="rounded" />
          <Skeleton className="h-3 w-24" rounded="rounded" />
          <Skeleton className="h-3 w-20" rounded="rounded" />
        </div>
        {/* Table rows */}
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="grid grid-cols-4 gap-4 px-6 py-4 border-b border-gray-50 dark:border-gray-700/50">
            <Skeleton className="h-4 w-28" rounded="rounded" />
            <Skeleton className="h-4 w-16" rounded="rounded-full" />
            <Skeleton className="h-4 w-32" rounded="rounded" />
            <Skeleton className="h-4 w-24" rounded="rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}
